import { useContext } from 'react';

import { useReactiveVar } from '@apollo/client';

import AccountContext from 'context/AccountContext';
import FeatureFlagsContext from 'context/FeatureFlagsContext';
import { featureCountryCode } from 'states/persistInStorage';
import { isAdyenCardAddEnabledForCountry } from 'utils/featureFlagUtils';

/**
 * Single source of truth for the Adyen card-add provider gate.
 *
 * Same inputs the MobilePay gate uses — the Firebase RC flag
 * `enable_adyen_card_add_by_country`, the app country (`featureCountryCode`), and
 * the customer email — resolved to one boolean. Dark by default; when true there
 * is NO Nets fallback. Kept as a hook (rather than repeating the flag/context
 * reads at each call site) so the entry hook, the add-payment modal (native +
 * web) and the onboarding navigator all gate identically.
 */
export const useAdyenCardAddEnabled = (): boolean => {
  const appCountry = useReactiveVar(featureCountryCode);
  const {
    flags: { enable_adyen_card_add_by_country },
  } = useContext(FeatureFlagsContext);
  const {
    customer: { contactEmail },
  } = useContext(AccountContext);

  return isAdyenCardAddEnabledForCountry(
    enable_adyen_card_add_by_country,
    appCountry,
    contactEmail
  );
};

export default useAdyenCardAddEnabled;
